// cleanup_remove_external_libraries_PAYMENT_MAPS
// cleanup_convert_to_typescript_file_PAYMENT_MAPS

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { template } from 'lodash';

import { BareCheckboxRadio as Checkbox } from '@glu/form-components';

import ThemedLink from 'components/themedLink/ThemedLink';
import useLocale from 'components/useLocale';

import { PROCESS_MODES_NAMES } from '../utils';
import { TABLE_FIELDS, TRANSACTION_FIELD_VARIANT } from './constants';
import useStyles from './Table.styles';

export const SharedRowPartComponent = ({
  cellClass = '',
  changeTransactionFieldVariant = null,
  field,
  fieldNameClassName,
  formState,
  onChange,
  processMode,
  sending,
  transactionFieldVariant,
  turnOnCheckboxes
}) => {
  const classes = useStyles();
  const locale = useLocale();
  const newTransactionVariant =
    transactionFieldVariant === TRANSACTION_FIELD_VARIANT.TRAN_TYPE
      ? TRANSACTION_FIELD_VARIANT.TRANSACTION_CODE
      : TRANSACTION_FIELD_VARIANT.TRAN_TYPE;

  const handleCheckboxCheck = useCallback(
    (name, checked) => {
      const checkboxIdStr = name.split('_');
      const fieldId = checkboxIdStr[0];
      const checkboxType = checkboxIdStr[checkboxIdStr.length - 1];

      const anotherCheckboxId = `${fieldId}_${checkboxType === 'match' ? 'update' : 'match'}`;

      onChange(name, checked);
      onChange(anotherCheckboxId, false); // if match is selected = clear update checkbox, and vice versa
    },
    [onChange]
  );

  const onTransactionVariantChange = useCallback(
    (e) => {
      e.preventDefault();
      changeTransactionFieldVariant(newTransactionVariant);
    },
    [newTransactionVariant, changeTransactionFieldVariant]
  );

  const switchTo = template(locale['wireImports.switchTo'])({
    destination: locale[`wireImports.${newTransactionVariant}`]
  });

  return (
    <>
      <div
        className={classnames(cellClass, fieldNameClassName, {
          [classes.optionalName]: field.optional && processMode !== PROCESS_MODES_NAMES.UPDATE_ONLY
        })}
      >
        {field.name}
        {transactionFieldVariant &&
          (field.id === TABLE_FIELDS.TRAN_TYPE || field.id === TABLE_FIELDS.TRAN_CODE) && (
            <ThemedLink
              className={classes.switchTransactionRowLink}
              data-qa={switchTo}
              onClick={onTransactionVariantChange}
            >
              {switchTo}
            </ThemedLink>
          )}
      </div>

      {turnOnCheckboxes && (
        <>
          <div
            className={classnames(
              cellClass,
              classes.updateCheckboxCell,
              classes.updateCheckbox,
              'tableCheckbox'
            )}
          >
            {field.match && (
              <Checkbox
                checked={formState[`${field.id}_match`]}
                data-qa={`${field.id}_match`}
                disabled={sending}
                htmlId={`${field.id}_match`}
                name={`${field.id}_match`}
                onChange={handleCheckboxCheck}
              />
            )}
          </div>

          <div
            className={classnames(
              cellClass,
              classes.updateCheckboxCell,
              classes.updateCheckbox,
              'tableCheckbox'
            )}
          >
            {field.update && (
              <Checkbox
                checked={formState[`${field.id}_update`]}
                data-qa={`${field.id}_update`}
                disabled={sending}
                htmlId={`${field.id}_update`}
                name={`${field.id}_update`}
                onChange={handleCheckboxCheck}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

SharedRowPartComponent.propTypes = {
  field: PropTypes.shape({}).isRequired,
  cellClass: PropTypes.string,
  sending: PropTypes.bool.isRequired,
  formState: PropTypes.shape({}).isRequired,
  processMode: PropTypes.string.isRequired,
  turnOnCheckboxes: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  changeTransactionFieldVariant: PropTypes.func
};

export default SharedRowPartComponent;
